<template>
  <div class="my-4 ml-3 rules" :class="{'show': showRules}">
    <p v-for="(rule, index) in passwordRules" :key="index" :class="{ 'fulfilled': rule.fulfilled, 'not-fulfilled': !rule.fulfilled }" style="margin: 0px;">
      <i v-if="rule.fulfilled" class="mdi mdi-check"></i>
      <i v-else class="mdi mdi-close"></i>
      {{ rule.description }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'PasswordRules',
  props: ['showRules', 'password'],
  computed: {
    passwordRules() {
      let rules = [
        {
          description: "contains lowercase, and uppercase letters",
          regex: /(?=.*[a-z])(?=.*[A-Z])/
        },
        {
          description: "contains at least one number",
          regex: /\d/
        },
        {
          description: "contains at least one special character",
          regex: /[\W_]/
        },
        {
          description: "longer than 8 characters",
          regex: /.{9,}/
        }
      ]

      return rules.map(rule => {
        return {
          description: rule.description,
          fulfilled: rule.regex.test(this.password)
        }
      })
    },
  }
}
</script>
<style scoped>
.fulfilled {
 color: green;
}
.not-fulfilled {
 color: red;
}
.rules {
  opacity: 0;
  max-height: 0px;
  transition: all 0.4s ease-in-out;
  overflow: hidden;
}
.rules.show {
  max-height: 150px;
  opacity: 1;
}
</style>